import { TAG_TYPES } from "@seneca/tags-service-consts";

import { getClient } from "services";

import { deleteTag as deleteTagAction } from "../state/admin";

export function makeDeleteTag(deleteActionFactory: any) {
  const deleteTag = deleteActionFactory({
    requestFunction: ({ id }: any) =>
      getClient("tagService").deleteTag(id, TAG_TYPES.tag),
    storeAction: deleteTagAction
  });

  const deleteCategory = deleteActionFactory({
    requestFunction: ({ id }: any) =>
      getClient("tagService").deleteTag(id, TAG_TYPES.category),
    storeAction: deleteTagAction
  });

  return {
    deleteTag,
    deleteCategory
  };
}
